<mat-card class="grid-card" id="page-content">
  <mat-card-content class="grid-card-content">
    <form class="form-container" [formGroup]="form">
      <mat-card class="grid-card">
        <mat-card-content class="search-form grid-card-content">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ "SEARCH" | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-lg-4 col-md-6 ps-0" *ngIf="canSeeInfo">
                <mat-form-field appearance="outline" class="w-100" [ngClass]="{
                    'error-margin':
                      form.get('complainantName')?.invalid &&
                      (form.get('complainantName')?.dirty ||
                        form.get('complainantName')?.touched)
                  }">
                  <mat-label>{{ "NAME" | translate }}</mat-label>
                  <input matInput formControlName="complainantName" size="small" />
                </mat-form-field>
              </div>

              <div class="col-lg-4 col-md-6 ps-0" *ngIf="canSeeInfo">
                <!-- <mat-form-field appearance="outline" class="w-100" [ngClass]="{'error-margin': form.get('cnic')?.invalid && (form.get('cnic')?.dirty || form.get('cnic')?.touched)}"
                > -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "CNIC" | translate }}</mat-label>
                  <input matInput formControlName="cnic" (input)="formatCnic($event)" maxlength="15" size="small" />
                  <!-- @if (f['cnic'].errors) {
                      <mat-error  >
                          @if (f['cnic'].errors['required']) { <span>{{'FIELD_REQUIRED' |
                              translate}}</span>}
                          @if (f['cnic'].errors['pattern']) { <span>{{'CNIC_PATTERN' |
                              translate}}</span>}
                          @if (f['cnic'].errors['minlength'] || f['cnic'].errors['maxlength']) { <span>{{'MINLENGTH_13' |
                              translate}}</span>}
                      </mat-error>
                  }  -->
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0" *ngIf="canSeeInfo">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "GENDER" | translate }}</mat-label>

                  <mat-select formControlName="gender">
                    <mat-option value="Male">Male</mat-option>
                    <mat-option value="Female">Female</mat-option>
                    <mat-option value="Transgender Person">Transgender Person</mat-option>
                  </mat-select>

                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0" *ngIf="canSeeInfo">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "PHONE" | translate }}</mat-label>
                  <input matInput formControlName="cellPhoneNo" size="small" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0" *ngIf="canSeeInfo">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "EMAIL" | translate }}</mat-label>
                  <input matInput formControlName="email" size="small" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "COMPLAINT_NO" | translate }}</mat-label>
                  <input matInput formControlName="complaintNo" />
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "COMPLAINT_TYPE" | translate }}</mat-label>
                  <mat-select formControlName="complaintCategoryId" (selectionChange)="clearSearch('category')">
                    <input #searchComplaint id="search-select" class="w-100 border-0 p-1"
                      placeholder="Search {{ 'COMPLAINT_TYPE' | translate }}"
                      (keyup)="filterComplaintCategory($event)" />
                    <mat-option>{{ "NONE" | translate }}</mat-option>
                    <mat-option *ngFor="let ct of categoryList" [value]="ct.complaintCategoryId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "COMPLAINT_SUBTYPE" | translate }}</mat-label>
                  <mat-select formControlName="complaintSubcategoryId" (selectionChange)="clearSearch('subCategory')">
                    <input #searchSubCat id="search-select" class="w-100 border-0 p-1"
                      placeholder="Search {{ 'COMPLAINT_SUBTYPE' | translate }}" (keyup)="filterSubCategory($event)" />
                    <mat-option>{{ "NONE" | translate }}</mat-option>
                    <mat-option *ngFor="let ct of subCategoryList" [value]="ct.complaintCategoryId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "DIVISION" | translate }}</mat-label>
                  <mat-select formControlName="divisionId" size="small" (selectionChange)="clearSearch('division')">
                    <input #searchDivision class="w-100 border-0 p-1" placeholder="Search {{ 'DIVISION' | translate }}"
                      (keyup)="filterDivisions($event)" />
                    <mat-option [value]="''">{{
                      "ALL" | translate
                      }}</mat-option>
                    <mat-option *ngFor="let ct of allDivisionList" [value]="ct.adminStrId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "DISTRICT" | translate }}</mat-label>
                  <mat-select formControlName="districtId" size="small" (selectionChange)="clearSearch('district')">
                    <input #searchDistrict id="search-select" class="w-100 border-0 p-1"
                      placeholder="Search {{ 'DISTRICT' | translate }}" (keyup)="filterDistricts($event)" />
                    <mat-option *ngFor="let ct of districtList" [value]="ct.adminStrId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "TEHSIL" | translate }}</mat-label>
                  <mat-select formControlName="tehsilId" size="small" (selectionChange)="clearSearch('tehsil')">
                    <input #searchTehsil id="search-select-tehsil" class="w-100 border-0 p-1"
                      placeholder="Search {{ 'TEHSIL' | translate }}" (keyup)="filterTehsil($event)" />
                    <mat-option *ngFor="let ct of tehsilList" [value]="ct.adminStrId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "MOUZA" | translate }}</mat-label>
                  <mat-select formControlName="mouzaId" size="small" (selectionChange)="clearSearch('mouza')">
                    <input #searchMouza id="search-select-mouza" class="w-100 border-0 p-1"
                      placeholder="Search {{ 'MOUZA' | translate }}" (keyup)="filterMouza($event)" />
                    <mat-option *ngFor="let ct of mouzaList" [value]="ct.adminStrId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "STATUS" | translate }}</mat-label>
                  <mat-select formControlName="currentProcessId" size="small"
                    (selectionChange)="clearSearch('currentProcess')">
                    <input #searchCurrentProcess id="search-select-status" class="w-100 border-0 p-1"
                      placeholder="Search {{ 'STATUS' | translate }}" (keyup)="filterStatus($event)" />
                    <mat-option>{{ "NONE" | translate }}</mat-option>
                    <mat-option *ngFor="let ct of complaintProcessList" [value]="ct.complaintProcessId">
                      {{ ct.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{'DATE_RANGE' | translate}}</mat-label>
                  <mat-date-range-input style="padding-top: 12px;" [rangePicker]="picker" [formGroup]="dateRangeForm" [disabled]="!selectedType">
                    <input matStartDate placeholder="Start date" formControlName="dateFrom">
                    <input matEndDate placeholder="End date" formControlName="dateTo" (dateChange)="onRangeChange()">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix (click)="clearDateRange()">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              </div> -->

              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "DATE_FROM" | translate }}</mat-label>
                  <input matInput [matDatepicker]="dateFromPicker" formControlName="dateFrom" />
                  <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateFromPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "DATE_TO" | translate }}</mat-label>
                  <input matInput [matDatepicker]="dateToPicker" formControlName="dateTo" />
                  <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateToPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-lg-4 col-md-6 ps-0">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ "ASSIGNEE" | translate }}</mat-label>
                  <mat-select formControlName="assignTo" size="small" [disabled]="assignRoleAdmin">
                    <mat-option [value]="''">{{ "ALL" }}</mat-option>
                    <mat-option *ngFor="let ct of usersList" [value]="ct.userId">
                      {{ ct.userName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>


            </div>

            <mat-card-actions class="d-flex justify-content-between align-items-center">
              <div>
                <mat-slide-toggle [checked]="preserveSearch" (change)="onPreserveSearchChange($event)" color="primary"
                  class="ml-2">
                  Preserve Search
                </mat-slide-toggle>
              </div>
              <div>
                <button mat-button class="btn-primary" color="primary" (click)="searchComplaints()">
                  {{ "SEARCH_BUTTON" | translate }}
                </button>
                <button mat-button class="btn-secondary ml-1 z-0" (click)="clear()">
                  {{ "CLEAR" | translate }}
                </button>
              </div>
            </mat-card-actions>
          </mat-expansion-panel>
        </mat-card-content>
      </mat-card>
    </form>
  </mat-card-content>
</mat-card>

<mat-card-content>
  <mat-card-title>{{ "COMPLAINTS" | translate }}</mat-card-title>
</mat-card-content>

<mat-card class="grid-card">
  <mat-card-content class="grid-card-content">
    <mat-grid-list cols="2" rowHeight="60px">
      <mat-grid-tile colspan="1" class="justify-start">
        <button mat-button [matMenuTriggerFor]="columnMenu" class="btn-secondary ml-1" color="primary">
          Select Column
          <svg height="10px" width="10px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000">
            <g id="SVGRepo_bgCarrier" stroke-width="0" />

            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

            <g id="SVGRepo_iconCarrier">
              <path style="fill: #04a251"
                d="M488.726,139.637H23.273c-9.883,0-18.689,6.242-21.96,15.569c-3.271,9.326-0.295,19.701,7.422,25.876 l232.733,186.181c4.25,3.399,9.394,5.1,14.538,5.1c5.143,0,10.29-1.7,14.538-5.1l232.72-186.181 c7.719-6.173,10.695-16.55,7.422-25.876C507.415,145.878,498.609,139.637,488.726,139.637z" />
            </g>
          </svg>
        </button>
        <mat-menu #columnMenu="matMenu">
          <div class="custom-menu">
            <mat-checkbox style="display: block; margin-bottom: 8px" disabled [checked]="selectedColumns['check-box']"
              (change)="toggleColumn('check-box', $event)" (click)="$event.stopPropagation()">
              {{ "Selection" }}
            </mat-checkbox>
            <mat-checkbox style="display: block; margin-bottom: 8px" disabled [checked]="selectedColumns['complaintNo']"
              (change)="toggleColumn('complaintNo', $event)" (click)="$event.stopPropagation()">
              {{ "COMPLAINT_NO" | translate }}
            </mat-checkbox>
            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['status']"
              (change)="toggleColumn('status', $event)" (click)="$event.stopPropagation()">
              {{ "STATUS" | translate }}
            </mat-checkbox>
            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['complainantName']" (change)="toggleColumn('complainantName', $event)"
              (click)="$event.stopPropagation()">
              {{ "COMPLAINANT_NAME" | translate }}
            </mat-checkbox>
            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['gender']" (change)="toggleColumn('gender', $event)"
              (click)="$event.stopPropagation()">
              {{ "GENDER" | translate }}
            </mat-checkbox>

            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['cellPhoneNo']" (change)="toggleColumn('cellPhoneNo', $event)"
              (click)="$event.stopPropagation()">
              {{ "PHONE" | translate }}
            </mat-checkbox>
            
            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['email']" (change)="toggleColumn('email', $event)"
              (click)="$event.stopPropagation()">
              {{ "EMAIL" | translate }}
            </mat-checkbox>

            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['cnic']" (change)="toggleColumn('cnic', $event)"
              (click)="$event.stopPropagation()">
              {{ "CNIC" | translate }}
            </mat-checkbox>

            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['passportNo']" (change)="toggleColumn('passportNo', $event)"
              (click)="$event.stopPropagation()">
              {{ "Passport Number" }}
            </mat-checkbox>
            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['citizenAddress']" (change)="toggleColumn('citizenAddress', $event)"
              (click)="$event.stopPropagation()">
              {{ "Citizen Address" }}
            </mat-checkbox>




            <mat-checkbox style="display: block; margin-bottom: 8px" disabled
              [checked]="selectedColumns['complaintCategoryName']"
              (change)="toggleColumn('complaintCategoryName', $event)" (click)="$event.stopPropagation()">
              {{ "COMPLAINT_TYPE" | translate }}
            </mat-checkbox>

            <mat-checkbox *ngIf="canSeeInfo" style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['complaintSubcategoryName']"
              (change)="toggleColumn('complaintSubcategoryName', $event)" (click)="$event.stopPropagation()">
              {{ "COMPLAINT_SUBTYPE" | translate }}
            </mat-checkbox>





            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['divisionName']"
              (change)="toggleColumn('divisionName', $event)" (click)="$event.stopPropagation()">
              {{ "DIVISION" | translate }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['districtName']"
              (change)="toggleColumn('districtName', $event)" (click)="$event.stopPropagation()">
              {{ "DISTRICT" | translate }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['tehsilName']"
              (change)="toggleColumn('tehsilName', $event)" (click)="$event.stopPropagation()">
              {{ "TEHSIL" | translate }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['mouzaName']"
              (change)="toggleColumn('mouzaName', $event)" (click)="$event.stopPropagation()">
              {{ "MOUZA" | translate }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['priority']"
              (change)="toggleColumn('priority', $event)" (click)="$event.stopPropagation()">
              {{ "Priority" }}
            </mat-checkbox>
            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['severity']"
              (change)="toggleColumn('severity', $event)" (click)="$event.stopPropagation()">
              {{ "Severity" }}
            </mat-checkbox>
            <!-- <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['complainantTitle']"
              (change)="toggleColumn('complainantTitle', $event)" (click)="$event.stopPropagation()">
              {{ "Complainant Type" }}
            </mat-checkbox> -->
            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['daysRequired']"
              (change)="toggleColumn('daysRequired', $event)" (click)="$event.stopPropagation()">
              {{ "Days Required" }}
            </mat-checkbox>
            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['legalFramework']"
              (change)="toggleColumn('legalFramework', $event)" (click)="$event.stopPropagation()">
              {{ "Legal Framework" }}
            </mat-checkbox>
            <mat-checkbox style="display: block; margin-bottom: 8px"
              [checked]="selectedColumns['expectedResolutionDate']"
              (change)="toggleColumn('expectedResolutionDate', $event)" (click)="$event.stopPropagation()">
              {{ "Expected Resolution Date" }}
            </mat-checkbox>
            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['complaintAddress']"
              (change)="toggleColumn('complaintAddress', $event)" (click)="$event.stopPropagation()">
              {{ "Complaint Address" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['description']"
              (change)="toggleColumn('description', $event)" (click)="$event.stopPropagation()">
              {{ "Description" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['complaintSource']"
              (change)="toggleColumn('complaintSource', $event)" (click)="$event.stopPropagation()">
              {{ "Source" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['assignToName']"
              (change)="toggleColumn('assignToName', $event)" (click)="$event.stopPropagation()">
              {{ "Assign To" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['assignToGroupName']"
              (change)="toggleColumn('assignToGroupName', $event)" (click)="$event.stopPropagation()">
              {{ "Group Assign To" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['workCode']"
              (change)="toggleColumn('workCode', $event)" (click)="$event.stopPropagation()">
              {{ "Work Code" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['helplineIdentifier']"
              (change)="toggleColumn('helplineIdentifier', $event)" (click)="$event.stopPropagation()">
              {{ "Helpline Identifier" }}
            </mat-checkbox>



            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['segmentName']"
              (change)="toggleColumn('segmentName', $event)" (click)="$event.stopPropagation()">
              {{ "Segment" }}
            </mat-checkbox>



            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['isAnonymous']"
              (change)="toggleColumn('isAnonymous', $event)" (click)="$event.stopPropagation()">
              {{ "Anonymous Complaint" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" [checked]="selectedColumns['otherSource']"
              (change)="toggleColumn('otherSource', $event)" (click)="$event.stopPropagation()">
              {{ "Other Forum" }}
            </mat-checkbox>

            <mat-checkbox style="display: block; margin-bottom: 8px" disabled [checked]="selectedColumns['action']"
              (change)="toggleColumn('action', $event)" (click)="$event.stopPropagation()">
              {{ "ACTION" | translate }}
            </mat-checkbox>
          </div>
        </mat-menu>
      </mat-grid-tile>
      <mat-grid-tile colspan="1" class="justify-end">
        <button mat-button class="btn-primary" color="primary" [routerLink]="'/complaint/add'">
          <mat-icon>add_circle</mat-icon>
          Add New Complaint
        </button>

        <button mat-button [matMenuTriggerFor]="menu" class="btn-secondary ml-1" color="primary">
          <mat-icon>file_download</mat-icon>
          Export
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="downloadAllAsPdf('all')">
            <mat-icon>picture_as_pdf</mat-icon>
            All as PDF
          </button>
          <button mat-menu-item (click)="downloadAllAsPdf('current')">
            <mat-icon>picture_as_pdf</mat-icon>
            Selected as PDF
          </button>
          <button mat-menu-item (click)="downloadAllAsExcel('all')">
            <mat-icon>grid_on</mat-icon>
            All as CSV
          </button>
          <button mat-menu-item (click)="downloadAllAsExcel('current')">
            <mat-icon>grid_on</mat-icon>
            Selected as CSV
          </button>
        </mat-menu>
      </mat-grid-tile>
    </mat-grid-list>

    @if (searchError) {
      <div class="search-error-state">
        <mat-icon>error_outline</mat-icon>
        <span>{{ 'SEARCH_FAILED' | translate }}</span>
      </div>
    }

    @if (isLoading) {
      <div class="skeleton-table">
        @for (row of [1,2,3,4,5,6,7,8]; track row) {
          <div class="skeleton-row">
            @for (col of [1,2,3,4,5,6]; track col) {
              <div class="skeleton-cell"></div>
            }
          </div>
        }
      </div>
    }

    <div class="table-responsive" [style.display]="isLoading ? 'none' : ''">
      <table mat-table [dataSource]="dataSource" matSort>
        <!-- ID Column -->
        <!-- <ng-container matColumnDef="sr">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Sr. No.' | translate}} </th>
                  <td mat-cell *matCellDef="let row; let i=index">{{i+1}} </td>
              </ng-container> -->
        <ng-container matColumnDef="check-box" sticky>
          <th mat-header-cell *matHeaderCellDef class="sticky-checkbox-col">
            <mat-checkbox class="header-checkbox" (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="sticky-checkbox-col">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="complaintNo" sticky>
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="sticky-complaintno-col">
            {{ "COMPLAINT_NO" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="sticky-complaintno-col">{{ row.complaintNo || "N/A"}}</td>
        </ng-container>
        <ng-container matColumnDef="complaintCategoryName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "COMPLAINT_TYPE" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.complaintCategoryName || "N/A"}}
          </td>
        </ng-container>
        <ng-container matColumnDef="complaintSubcategoryName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "COMPLAINT_SUBTYPE" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.complaintSubcategoryName || "N/A" }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "STATUS" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.currentProcess.name || "N/A"}}</td>
        </ng-container>
        <ng-container matColumnDef="cnic">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cnic-column-header">
            {{ "CNIC" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="cnic-column-cell">
            {{ row.cnic || "N/A" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "GENDER" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.gender || "N/A"}}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "EMAIL" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.email || "N/A"}}</td>
        </ng-container>
        <ng-container matColumnDef="complainantName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "COMPLAINANT_NAME" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.complainantName }}</td>
        </ng-container>
        <ng-container matColumnDef="cellPhoneNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "PHONE" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.cellPhoneNo || "N/A"}}</td>
        </ng-container>
        <ng-container matColumnDef="divisionName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="division-column-header">
            {{ "DIVISION" | translate }}
          </th>
          <td mat-cell *matCellDef="let row" class="division-column-cell">
            {{ row.divisionName || "N/A"}}
          </td>
        </ng-container>

        <!-- New Columns -->
        <ng-container matColumnDef="districtName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "DISTRICT" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.districtName|| "N/A" }}</td>
        </ng-container>

        <ng-container matColumnDef="tehsilName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "TEHSIL" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.tehsilName || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="mouzaName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "MOUZA" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.mouzaName || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Priority" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.priority || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="severity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Severity" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.severity || "N/A"}}</td>
        </ng-container>

        <!-- <ng-container matColumnDef="complainantTitle">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Complainant Type" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.complainantTitle }}</td>
        </ng-container> -->

        <ng-container matColumnDef="daysRequired">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Days Required" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.daysRequired || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="legalFramework">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Legal Framework" }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="description-cell" [matTooltip]="row.legalFramework">
              {{ row.legalFramework || "N/A"}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expectedResolutionDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Expected Resolution Date" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ (row.expectedResolutionDate | date) || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="complaintAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Complaint Address" }}
          </th>

          <td mat-cell *matCellDef="let row">
            <div class="description-cell" [matTooltip]="row.complaintAddress">
              {{ row.complaintAddress|| "N/A"}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Description" }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="description-cell" [matTooltip]="row.complaintDetails | stripHtml">
              {{ (row.complaintDetails | stripHtml)|| "N/A"}}
            </div>
          </td>
        </ng-container>


        <ng-container matColumnDef="complaintSource">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Source" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.complaintSource || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="assignToName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Assign To" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.assignToName|| "N/A" }}</td>
        </ng-container>

        <ng-container matColumnDef="assignToGroupName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Group Assign To" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.assignToGroupName|| "N/A" }}</td>
        </ng-container>

        <ng-container matColumnDef="workCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Work Code" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.workCode|| "N/A" }}</td>
        </ng-container>

        <ng-container matColumnDef="helplineIdentifier">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Helpline Identifier" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.helplineIdentifier || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="passportNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Passport Number" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.passportNo || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="segmentName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Segment" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.segmentName || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="citizenAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Citizen Address" }}
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="description-cell" [matTooltip]="row.address">
              {{ row.address || "N/A"}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="isAnonymous">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Anonymous Complaint" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.isAnonymous ? 'Yes' : 'No' }}</td>
        </ng-container>

        <ng-container matColumnDef="otherSource">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Other Forum" }}
          </th>
          <td mat-cell *matCellDef="let row">{{ row.otherSource || "N/A"}}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>{{ "ACTION" | translate }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div class="d-flex justify-content-end" style="width: 120px">



              <!-- @if(!row?.isAnonymous) { -->
              @if(isValidEmail(row.email) && !['closed', 'appeal closed', 'drop'].includes(row?.currentProcess?.name?.toLowerCase() || '')) {
              <img src="assets/img/email.svg" class="appeal-icons-email" (click)="sendEmail(row)" alt="" title="Send Email" />
              }
              @if(isValidMobile(row.cellPhoneNo) && !['closed', 'appeal closed', 'drop'].includes(row?.currentProcess?.name?.toLowerCase() || '')) {
              <img src="assets/img/sms.svg" class="appeal-icons" (click)="sendSms(row)" alt="" title="Send SMS" />
              }

              <img src="assets/img/edit.svg" class="appeal-icons" (click)="edit(row, i)" alt=""
                title="Edit Complaint" />

              @if (['closed'].includes(row?.currentProcess?.name?.toLowerCase())) {
              <img src="assets/img/appeal.svg" class="appeal-icons" (click)="openAppealModal(row)" alt=""
                title="Appeal" />
              } @if (!['closed', 'drop', 'appeal closed'].includes(row?.currentProcess?.name?.toLowerCase())) {
              <img src="assets/img/drop.svg" class="appeal-icons" (click)="openDropModal(row)" alt="" title="Drop Complaint" />
              }
              @if(showReopenButton(row)) {
              <img src="assets/img/reopen.svg" class="appeal-icons" (click)="openReopenModal(row)" alt=""
                title="Reopen Complaint" />
              }

            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell mat-cell-left-padding-10" colspan="4">
            {{ "NO_DATA_FOUND" | translate }}
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator [pageSizeOptions]="config.pageSizeOptionsList" (page)="handlePageEvent($event)" [pageSize]="pageSize"
      [length]="length" [pageIndex]="pageIndex" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>